var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChiraCeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1814"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u6955\\u5186\\u5F62 36",
    fill: "rgba(255,255,255,0)",
    stroke: "#bbb",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-arrow-up",
    d: "M10.25 18.389l-.812-.812a.874.874 0 010-1.24l7.106-7.113a.874.874 0 011.239 0l7.106 7.11a.874.874 0 010 1.24l-.812.812a.879.879 0 01-1.254-.015l-4.195-4.4v10.51a.876.876 0 01-.878.878h-1.167a.876.876 0 01-.878-.878V13.968l-4.2 4.407a.872.872 0 01-1.254.015z",
    fill: "#bbb"
  }))));
}

export default SvgIconChiraCeo;